var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "attachment",
      on: {
        "!focus": function($event) {
          return _vm.setFocused(true)
        },
        "!blur": function($event) {
          return _vm.setFocused(false)
        }
      }
    },
    [
      !_vm.hasFile && !_vm.isReadOnly
        ? _c(
            "label",
            {
              class: [
                _vm.focused ? "underline" : "",
                "btn btn-contrast btn-link-custom"
              ],
              attrs: { for: _vm.inputId }
            },
            [
              _c("i", { staticClass: "fas fa-paperclip" }),
              _vm._v(" " + _vm._s(_vm.$t("Attachment.Download")) + "\n  ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("file-upload", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hasFile && !_vm.isReadOnly,
            expression: "!hasFile && !isReadOnly"
          }
        ],
        ref: "upload",
        attrs: {
          headers: _vm.getHeaders(),
          "post-action": _vm.action,
          extensions: _vm.acceptedExtensions,
          accept: _vm.validTypesFilter,
          multiple: false,
          size: _vm.maxSize,
          "input-id": _vm.inputId
        },
        on: { "input-filter": _vm.inputFilter, "input-file": _vm.inputFile },
        model: {
          value: _vm.files,
          callback: function($$v) {
            _vm.files = $$v
          },
          expression: "files"
        }
      }),
      _vm._v(" "),
      _vm.hasFile && !_vm.isReadOnly
        ? _c(
            "button",
            {
              staticClass: "btn btn-contrast btn-link-custom",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.deleteAttachment()
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-trash-alt" }),
              _vm._v(" " + _vm._s(_vm.$t("Attachment.Delete")) + "\n  ")
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }